import { render, staticRenderFns } from "./CampanhaInternaAudienciasApp.vue?vue&type=template&id=16a9249f&scoped=true"
import script from "./CampanhaInternaAudienciasApp.vue?vue&type=script&lang=js"
export * from "./CampanhaInternaAudienciasApp.vue?vue&type=script&lang=js"
import style0 from "./CampanhaInternaAudienciasApp.vue?vue&type=style&index=0&id=16a9249f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a9249f",
  null
  
)

export default component.exports